import React from 'react';

type Props = {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  expectedType?: 'number' | 'string';
  enumValues?: string[];
};

const LiteralEditor: React.FC<Props> = ({
  value,
  onChange,
  onSubmit,
  onCancel: _onCancel,
  expectedType = 'number',
  enumValues = [],
}) => {
  if (expectedType === 'string' && enumValues.length > 0) {
    return (
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onSubmit} // Trigger submit on blur
        onKeyPress={(e) => e.key === 'Enter' && onSubmit()} // Trigger submit on Enter
        className="border p-1 rounded text-sm w-24"
      >
        <option value="">Select...</option>
        {enumValues.map(val => (
          <option key={val} value={val}>{val}</option>
        ))}
      </select>
    );
  }

  return (
    <input
      type="number"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onSubmit} // Trigger submit on blur
      onKeyPress={(e) => e.key === 'Enter' && onSubmit()} // Trigger submit on Enter
      className="border p-1 rounded text-sm w-24"
    />
  );
};

export default LiteralEditor;